import { render } from "./SwdNativeSelect.vue?vue&type=template&id=60876a1e"
import script from "./SwdNativeSelect.vue?vue&type=script&lang=js"
export * from "./SwdNativeSelect.vue?vue&type=script&lang=js"

import "./SwdNativeSelect.vue?vue&type=style&index=0&id=60876a1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__